import Vue from "vue";
import App from "@/app/App.vue";
import router from "./shared/router";
import store from "./shared/store";
import "animate.css";
import "./shared/plugins/ant-design-vue.js";
import './shared/plugins/infinite-scroll'
import "./shared/plugins/im";
import "./assets/style.scss";
import "@/shared/element-variables.scss"
import '@/app/admin/system/ai/resize';
import * as filters from "@/shared/utils/filter";
import VueClipboard from 'vue-clipboard2';
import { Cascader, CascaderPanel,Steps,Step } from 'element-ui';
import VueScrollTo from 'vue-scrollto'

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);
Vue.use(Cascader);
Vue.use(Steps);
Vue.use(Step);
Vue.use(VueScrollTo);
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

Vue.prototype.$bus = new Vue() // event Bus 用于无关系组件间的通信。

Vue.config.productionTip = false;

export default new Vue({
  router,
  store,
  render: h => h(App)
});
